import axios from 'axios'

const apiClient = axios.create({
    baseURL: '/form',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
})

export default {
    config(payload) {
        return apiClient.post(`/config`, payload);
    },
    rent(formData, token) {
        return apiClient.post(`/rent-request`, formData, {
            headers: {
                ...apiClient.defaults.headers,
                'X-CSRF-Token': token
            }
        });
    },
    contact(formData, token) {
        return apiClient.post(`/contact-request`, formData, {
            headers: {
                ...apiClient.defaults.headers,
                'X-CSRF-Token': token
            }
        });
    },
    sale(formData, token) {
        return apiClient.post(`/sale-request`, formData, {
            headers: {
                ...apiClient.defaults.headers,
                'X-CSRF-Token': token
            }
        });
    }
}
